import { createSlice } from '@reduxjs/toolkit';
import { findDashboardUser } from './api';
import { initialState } from './api/interface';

const dashboardUserSlice = createSlice({
  name: 'dashboardUser',
  initialState,
  reducers: {
    setLimit: (state, action) => {
      state.limit = action.payload.limit;
      state.status = 'idle';
    },
    setSkip: (state, action) => {
      state.skip = action.payload.skip;
      state.status = 'idle';
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload.currentPage;
    },
    removeUserById: (state, action) => {
      state.data = state.data.filter((user) => user.id !== action.payload.id);
    },
    setStatus: (state, action) => {
      state.status = action.payload.status;
    },
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(findDashboardUser.pending, (state) => {
      state.isLoading = true;
      state.status = 'pending';
    });
    builder.addCase(findDashboardUser.fulfilled, (state, action) => {
      state.data = action.payload.data;
      state.totalRecords = action.payload.total;
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
      state.status = 'succeeded';
    });
    builder.addCase(findDashboardUser.rejected, (state, _) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.status = 'failed';
    });
  },
});

export const { setLimit, setSkip, setCurrentPage, removeUserById, reset, setStatus } = dashboardUserSlice.actions;
export default dashboardUserSlice.reducer;